// extracted by mini-css-extract-plugin
export default {"container":"Al-z","bubbleNav":"Bl-z","graphic":"Cl-z","contact":"Dl-z"};